export const baseUrlUser = "https://showcaseapi.trezi.com/uus/api/v1/";
export const baseUrl = "https://lensservice.trezi.com/";
export const baseUrlUser1 = "http://125.63.103.149:8080/uus/api/v1/";
export const baseUrl1 = "http://125.63.103.147:8080/";


 export const baseUrlDashboard = "https://showcaseapi.trezi.com/dashboards/api/v1/";
export const getCookie = (name) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const cookies = document.cookie.split(";");
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].split("=");
        if (cookie[0] === name) {
          resolve(cookie[1]);
          return;
        }
      }
      resolve(null);
    }, 100);
  });
};


export const getTokenFromLocalStorage = () => {
  return localStorage.getItem('treziAccessToken'); // Assuming your JWT token is stored with the key 'jwt'
};

export const interceptor = (axiosInstance) => {
  axiosInstance.interceptors.request.use(async (request) => {
    const token = getTokenFromLocalStorage();
    // console.log("token", token);
    if (token) {
      request.headers.Authorization = `Bearer ${token}`;
      
    }
    return request;
  });

  return axiosInstance;
};